import React from 'react';
import '../../../less/index.less';
import '../less/eca.less';
import hero_img from '../img/hero_img.svg';
import Hero from '../../../../../../../auxiliary-components/shared/HeroBlock';
import InfoBlock from '../../../../../../../auxiliary-components/shared/InfoBlock';
import BusinessOrder from '../../../../../../BusinessOrder';
import hero_data from '../enums/hero_data.json';
import AdditionalProduct from './../../../../../../../auxiliary-components/shared/AdditionalProductBlock';
import additional_cards from '../enums/additional_cards_data.json';
import { getUrl } from "utils/corploansUrl";
import FilesForDownloadNew from './../../../../../../../auxiliary-components/shared/FilesForDownloadNew';

export default function template() {
    const page = 'business-gov-eca';
      
    const handlersMap = {
      toggleHeroModal: () => this.toggleModal()
    };

    const linksMap = {
      corploansDefaultLink: getUrl(),
      corploansLoanlineLink: getUrl('loanline'),
    };

    const heroData = {
      ...hero_data,
      link: {
        ...hero_data.link,
        onClick: handlersMap[hero_data.link.onClick],
      },
    };

    const additionalCards = additional_cards.map(item => ({
      ...item,
      link: linksMap[item.link],
      link2: linksMap[item.link2]
    }));

    return (
      <div className="business-gov-eca">
        <Hero
          data={heroData}
          img={hero_img}
          svg
          page={page}
          className="gov-programs"
        />
        <div className="content">
          <div className="we-support-row">
            <div className="container">
              <h2 className="we-support-row__title">{this.l10n('BUSINESS_GOV_ECA_NEW_WE_SUPPORT_TITLE')}</h2>
              <div className="we-support-row__body">
                <div className="we-support-row__left">
                  <p>{this.l10n('BUSINESS_GOV_ECA_NEW_WE_SUPPORT_TEXT_01')}</p>
                </div>
                <InfoBlock 
                  text={'BUSINESS_GOV_ECA_NEW_INFO_TEXT'}
                />
              </div>
            </div>
          </div>
          <AdditionalProduct
            items={additionalCards}
            title={'BUSINESS_GOV_ECA_NEW_ADDITIONAL_PRODUCT_TITLE'}
            page={page}
          />
          <FilesForDownloadNew
            widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
            loader={this.state.loader}
          />
        </div>
        {this.state.showModal && <BusinessOrder attribute="eca" closeModal={this.toggleModal} />}
      </div>
    );
}
